import { Navigate } from 'react-router-dom';

export default function Kanban() {
  return <Navigate to="/okrs?view=board" replace />;
}
